<template>
	<div
		id="app"
		@touchmove="prevent"
		@click.stop="fakeOverlay"
	>
		<ns-header></ns-header>
		<page-cta></page-cta>
		<create-signature></create-signature>
		<generated-signature></generated-signature>
		<instructions :class="{shadowBottom: !blogPosts.length}"></instructions>
		<blog v-if="blogPosts.length"></blog>
		<products></products>
		<ns-footer></ns-footer>
	</div>
</template>

<script>

	import { weDontUseJQuery } from "@/plugin/mixins";

	export default {
		name: 'app',
		data() {
			return {

			}
		},
		computed: {
			mobileMenuIsOpen() {
				return this.$store.mobileMenuIsOpen
			},
			blogPosts() {
				return this.$store.state.blogPosts;
			}
		},
		methods: {
			prevent(e) {
				if (this.mobileMenuIsOpen) {
					e.preventDefault();
					e.stopPropagation();
				}
			},
			fakeOverlay() {
				this.$store.commit('updateHeaderDropdownEl', null);
			}
		},
		components: {
			nsHeader: () => import('Components/header'),
			pageCta: () => import('Components/pageCta'),
			createSignature: () => import('Components/createSignature'),
			generatedSignature: () => import('Components/generatedSignature'),
			instructions: () => import('Components/instruction'),
			blog: () => import('Components/blog'),
			products: () => import('Components/products'),
			nsFooter: () => import('Components/footer')
		},
		async mounted() {
			await this.$store.dispatch('getBlogPosts')
		},
		mixins: [weDontUseJQuery]
	}
</script>

<style lang="scss">
	@import "styles/app";
</style>